import { Table, Column, useServerListApi } from '@2r/frontend-component-library';
import { VmUser } from '../model/VmUser';

export function FrameListUsers() {
    const ColumnNames: Column<VmUser>[] = [
        { Name: 'id', Label: 'ID' },
        { Name: 'username', Label: 'Nutzername' },
        { Name: 'email', Label: 'Email' },
        { Name: 'isDavid', Label: 'David/Clearo' },
        { Name: 'interfaces.0', Label: 'Schnittstelle' },
    ];

    const modul = useServerListApi<VmUser>({
        name: 'Benutzer',
        path: '/users',
        Columns: ColumnNames,
        embedded: false
    });

    return <Table<VmUser> {...modul.defaultTableProps} />;
}